module.exports = __webpack_public_path__ + "f86d7fd800079661a8450af83a97364c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorLIQUOR.jpg
// module id = 1042
// module chunks = 1